import React from "react";
import { useTranslation } from "react-i18next";

import { useAppSelector, useAppDispatch } from "store/index";
import { handleUpdateFieldTranslation } from "store/emails/slice";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import SwitchBtn from "components/buttons/SwitchBtn";
import TextEditor from "components/wysiwyg/Wysiwyg";

import styles from "../../email/NotificationEmailEditModal.module.scss";
import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";

interface Props {
  activeLocale: string;
  setActiveLocale: (e: string) => void;
  readOnly?: boolean;
}

const EmailLocalesTab: React.FC<Props> = ({
  activeLocale,
  setActiveLocale,
  readOnly
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const localesList = useAppSelector((store) => store.settings.locales);
  const translation = useAppSelector(
    (store) => store["emails"].translations[activeLocale]
  );
  const isTranslationLoaded = translation !== undefined;

  const handleFieldChange = (
    key: keyof typeof translation,
    value: string | number | boolean
  ) => {
    dispatch(
      handleUpdateFieldTranslation({
        ...translation,
        locale: activeLocale,
        [key]: value,
      })
    );
  };

  return (
    <>
      <div className={`game-modal-tabs small ${styles["email-tabs"]}`}>
        {localesList?.map((el) => (
          <div
            className={`tab-item ${activeLocale === el ? "active" : ""}`}
            key={el}
            onClick={() => {
              setActiveLocale(el);
            }}
          >
            <img
              src={`https://flagpedia.net/data/flags/icon/16x12/${el
                .split("-")[1]
                ?.toLowerCase()}.png`}
              alt=""
            />
            {t(el)}
          </div>
        ))}
      </div>

      {!isTranslationLoaded ? (
        <ModalTabSkeleton />
      ) : (
        <div className="tournament-rules-form">
          <div className="row">
            <div className="bonus-form-box--item" style={{ flex: 1 }}>
              <InnerInput
                value={translation?.title ?? ""}
                placeholder={t("enterTitle")}
                label={t("title")}
                type="text"
                id="bonus-translation-title"
                onChange={(e) => handleFieldChange("title", e)}
                disabled={!activeLocale || readOnly}
              />
            </div>

            <div className="bonus-form-box--item">
              <SwitchBtn
                activeTxt={t("active")}
                isActive={!!translation?.isActive}
                handleClick={() =>
                  handleFieldChange("isActive", translation?.isActive ? 0 : 1)
                }
                disabled={readOnly}
              />
            </div>
          </div>

          <div className="bonus-form-box--item html-editor">
            <div className="label">{t("content")}</div>

            <TextEditor
              value={translation?.content ?? ""}
              onChange={(e) => handleFieldChange("content", e)}
              disabled={!activeLocale || readOnly}
            />
          </div>
        </div>
      )}
    </>
  );
};


export default EmailLocalesTab;
